import { Box, Typography } from "@mui/material";
import MCard from "@mui/material/Card";
import MCardContent from "@mui/material/CardContent";
import MIconButton from "@mui/material/IconButton";
import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";

export const LoadingContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  flexDirection: "column",
});

export const BoxContainer = styled(Box)(() => ({
  width: "100px",
}));

export const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 6,
  borderRadius: 12,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.secondary.main,
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.primary.main,
  },
}));

export const Container = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
}));

export const Card = styled(MCard)(({ theme }) => ({
  justifyContent: "flex-start",
  zIndex: 100,
  [theme.breakpoints.up("md")]: {
    position: "absolute",
    left: 16,
    right: 16,
    bottom: 16,
  },
  [theme.breakpoints.down("md")]: {
    marginLeft: "-24px",
    marginRight: "-24px",
    marginBottom: "-24px",
  },
}));

export const CardContent = styled(MCardContent)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: "16px !important",
  gap: 8,

  [theme.breakpoints.up("md")]: {
    gap: 24,
  },
}));

export const CardContentWrapper = styled("div")(() => ({
  flex: 1,
}));

export const CardTitle = styled(Typography)(() => ({
  fontSize: "12px",
  lineHeight: "16px",
  fontWeight: 600,
  display: "flex",
  alignItems: "center",
}));

export const CardText = styled(Typography)(() => ({
  fontSize: "16px",
  lineHeight: "24px",
  display: "flex",
  alignItems: "center",
}));

export const CardTextContent = styled("strong")(() => ({
  marginLeft: "8px",
}));

export const IconButton = styled(MIconButton)<{ disabled?: boolean }>(({ theme, disabled }) => ({
  border: `1px solid ${
    disabled ? theme.palette.text.disabled : theme.palette.text.primary
  } !important`,
  borderRadius: "8px",
}));
